module.exports = __webpack_public_path__ + "img/pro_feature_flight_status.9c6edda.png";